import { render, staticRenderFns } from "./SelectProductsSection.vue?vue&type=template&id=5ee4413f&scoped=true"
import script from "./SelectProductsSection.vue?vue&type=script&lang=js"
export * from "./SelectProductsSection.vue?vue&type=script&lang=js"
import style0 from "./SelectProductsSection.vue?vue&type=style&index=0&id=5ee4413f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4413f",
  null
  
)

export default component.exports